import React, { type FunctionComponent } from 'react'
import { Divider } from '@retailer-platform/shared-components/src/tds'
import { spacing } from '@retailer-platform/shared-components'
import styled from '@emotion/styled'
import {
  Input,
  PropertyTitle,
  SectionHeader,
  FullWidthProperty,
} from '../../shared-styled-components/SharedStyledComponents'
import { useDomainMessages } from '../../../utils/domain/intl'
import { type FormProps } from './StepAttributeForm'

const StyledPropertyTitle = styled(PropertyTitle)({
  minWidth: '200px',
})

export const DataBridgeForm: FunctionComponent<FormProps> = ({
  attributes,
  mode,
  onChange,
  version,
}) => {
  const i18n = useDomainMessages({
    DataBridgeDetails: 'catalogAdminDomain.attributeManagement.form.dataBridge.details',
    DataBridgeName: 'catalogAdminDomain.attributeManagement.form.dataBridge.name',
  })

  return (
    <>
      <SectionHeader>{i18n.DataBridgeDetails}</SectionHeader>
      <FullWidthProperty
        style={{
          gap: '12px',
          justifyContent: 'flex-start',
          paddingTop: spacing.X8,
          paddingBottom: spacing.X8,
        }}
      >
        <StyledPropertyTitle>{i18n.DataBridgeName}</StyledPropertyTitle>
        {mode !== 'edit' ? (
          <div>{attributes.bridgeName}</div>
        ) : (
          <Input
            value={attributes.bridgeName}
            onChange={event => onChange({ ...attributes, bridgeName: event.target.value })}
            style={{ minWidth: '300px', maxWidth: '700px', width: 'auto' }}
          />
        )}
      </FullWidthProperty>
      <Divider />
    </>
  )
}
